import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { onMounted, ref, watch } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseAlert from "@/components/BaseAlert.vue";

// Warns the agent that the customer has convenience fees that were missed on a
// past payment and will be recovered on this one. Display-only: the server
// (convenience_fee endpoint) enforces the actual charge, so a failure to fetch
// here never lets the fee be skipped.

export default /*#__PURE__*/_defineComponent({
  props: {
  facilityId: {
    type: String,
    default: null,
  },
  customerId: {
    type: [String, Number],
    default: null,
  },
},
  emits: ["total"],
  setup(__props, { expose, emit }) {

const props = __props



// Emits the fetched outstanding total so a parent payment view can fold it into
// the displayed convenience fee / total (the backend charges it either way).


const total = ref(0);

async function fetchOutstanding() {
  if (!props.facilityId || props.customerId === null) {
    total.value = 0;
    emit("total", 0);
    return;
  }
  try {
    const response = await api({
      url: `outstanding_convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`,
      method: "GET",
    });
    // api() returns ApiError | ApiSuccess; body only exists on success.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const body = response.body;
    if ([200, 201].includes(response.status) && body) {
      total.value = Number(body.total || 0);
    } else {
      total.value = 0;
    }
  } catch (e) {
    total.value = 0;
  }
  emit("total", total.value);
}

onMounted(fetchOutstanding);
watch(() => [props.facilityId, props.customerId], fetchOutstanding);

expose({ total });

return (_ctx: any,_cache: any) => {
  return (total.value > 0)
    ? (_openBlock(), _createBlock(BaseAlert, {
        key: 0,
        variant: "danger",
        large: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" A previously missed convenience fee of $" + _toDisplayString(total.value.toFixed(2)) + " will also be applied to this customer on this payment. ", 1)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})